export default __webpack_public_path__ + "static/media/person_2@2x.e8235cd3.png";